import moment from 'moment';

export const abbreviateLabel = (typeLabel: string) =>
    typeLabel
        .split(' ')
        .map((w) => w[0].toUpperCase())
        .join('');

export const getEpisodeLabel = (typeLabel: string, numberInSequence?: number | null) =>
    numberInSequence ? `${typeLabel} #${numberInSequence}` : typeLabel;

export const getAllEpisodesLabel = (typeLabel: string, count: number) =>
    `All ${typeLabel} (${count})`;

export const getEpisodeNotesLabel = (typeLabel: string) => `${typeLabel} Notes`;

export const getEpisodeNotesHeadline = (typeLabel: string) =>
    `Notes about the current ${typeLabel.toLowerCase()}`;

export const getEpisodeNotesDescription = (typeLabel: string) =>
    `These notes will be visible to clinicians who are assigned to visits in this ${typeLabel.toLowerCase()}.`;

const EPISODE_DATE_FORMAT = 'ddd, MMM D, YYYY';

export const formatEpisodeWindow = (startDate: Date, endDate: Date, format?: string): string =>
    moment(startDate).format(format ?? EPISODE_DATE_FORMAT) +
    ' – ' +
    moment(endDate).format(format ?? EPISODE_DATE_FORMAT);
